import { BasicEntity } from "../../core/models/basic-entity";

export class TaxType extends BasicEntity {
    public FormattedName?:string;
   
    constructor(entity?: Partial<TaxType>) {
        super();
        Object.assign(this, entity);
    }
}